import type { ListOption } from '../GenericBloc/GenericShortListFilter/GenericShortListDropdown';

export enum DEVICE_TYPE {
  DESKTOP = 'desktop',
  TABLET = 'tablet',
  PHONE = 'phone',
}

export const ALL_DEVICE_TYPES = [
  DEVICE_TYPE.DESKTOP,
  DEVICE_TYPE.TABLET,
  DEVICE_TYPE.PHONE,
] as const;

export const DEVICE_FILTER_OPTIONS: ListOption<DEVICE_TYPE>[] = [
  { value: DEVICE_TYPE.DESKTOP, label: 'desktop', icon: 'device_desktop' },
  { value: DEVICE_TYPE.TABLET, label: 'tablet', icon: 'device_tablet' },
  { value: DEVICE_TYPE.PHONE, label: 'phone', icon: 'device_phone' },
];
